import React from 'react';
import { SpaEscrowExpectedHeaderContainer } from './SpaEscrowExpectedHeaderContainer';
import { FetchStatusFlow, Grid, Spinner } from '../../../../../ui-toolkit';
import { SpaEscrowBalancesHeaderContainer } from './SpaEscrowBalancesHeaderContainer';
import { SpaEscrowExpectedHeader } from './SpaEscrowExpectedHeader';
import { SpaEscrowBalancesHeader } from './SpaEscrowBalancesHeader';
import { useSelectCurrentOrder } from '../../../../../selectors/order/selectCurrentOrder';
import { useSelector } from 'react-redux';
import { RootStore } from '../../../../../store/types';
import { eTransactionCategory } from '../../../../../ui-toolkit/enums/eTransactionType';

interface ISpaBalancesExpectedHeaderProps {}

export const SpaBalancesExpectedHeader: React.FC<ISpaBalancesExpectedHeaderProps> = () => {
  const { data: order } = useSelectCurrentOrder();
  const { escrowBalancesHeaderSlice, escrowFormDataSlice } = useSelector((store: RootStore) => store.order.escrow);
  return (
    <FetchStatusFlow
      fetchStatus={escrowBalancesHeaderSlice.fetchStatus}
      error={escrowBalancesHeaderSlice.fetchError}
      fetchingNode={
        <Grid columnCount={3} alignItems={'stretch'}>
          <SpaEscrowExpectedHeader
            expectedBorrowerCash={<Spinner />}
            expectedBuyerCash={<Spinner />}
            expectedLenderCash={<Spinner />}
            loanAmount={null}
            transactionCategory={eTransactionCategory.Refinance}
          />
          <SpaEscrowBalancesHeader
            actual={<Spinner />}
            available={<Spinner />}
            totalDeposits={<Spinner />}
            totalDisbursements={<Spinner />}
          />
        </Grid>
      }
    >
      <Grid columnCount={3} alignItems={'stretch'}>
        <SpaEscrowExpectedHeaderContainer escrowBalancesHeaderSlice={escrowBalancesHeaderSlice} orderData={order} />
        <SpaEscrowBalancesHeaderContainer
          escrowBalancesHeaderSlice={escrowBalancesHeaderSlice.data}
          escrowFormDataSlice={escrowFormDataSlice}
        />
      </Grid>
    </FetchStatusFlow>
  );
};
